import * as React from 'react';
import ForwardingForm from './ForwardingForm';
import ForwardingOptionState, { ForwardingChoice } from '../store/schema/ForwardingOptionState';
import getChoiceGroupSelection from '../utils/getChoiceGroupSelection';
import setChoiceGroupSelectionState from '../actions/setChoiceGroupSelectionState';
import store from '../store/store';
import strings from 'owa-strings/owa-options-strings';
import { OptionDescription } from 'owa-options-controls';
import { OptionsCheckbox } from 'owa-options-controls';
import { reactive } from 'satcheljs/lib/legacy/react';

export interface ForwardingFullProps {
    optionState?: ForwardingOptionState;
}

@reactive({
    optionState: () => store,
})
export default class ForwardingFull extends React.Component<ForwardingFullProps, {}> {
    render() {
        const selectedKey = getChoiceGroupSelection();

        return (
            <div>
                <OptionDescription>{strings.options_forwarding_description}</OptionDescription>
                <OptionsCheckbox
                    label={strings.options_forwarding_checkbox}
                    checked={selectedKey === 'start'}
                    onChange={this.onChange}
                />
                <ForwardingForm />
            </div>
        );
    }

    private onChange = (ev: React.FormEvent<HTMLElement | HTMLInputElement>, checked: boolean) => {
        const key: ForwardingChoice = checked ? 'start' : 'stop';
        setChoiceGroupSelectionState(key);
    };
}
